export const SET_CAMPAIGN = 'WA/SET_CAMPAIGN'
export const SET_CAMPAIGNS = 'WA/SET_CAMPAIGNS'
export const SET_CONTACTS = 'WA/SET_CONTACTS'
